import { render, staticRenderFns } from "./PlantVarietyPriorityList.vue?vue&type=template&id=5814f76f&"
import script from "./PlantVarietyPriorityList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyPriorityList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyPriorityList.vue?vue&type=style&index=0&id=5814f76f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports